import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import { HomePageOptionsCardTemplate } from './HomePageOptionsCardTemplate';
import { rem } from 'polished';

export const HomePageOptionsCardStyled = styled(HomePageOptionsCardTemplate)`
    min-height: ${rem(300)};
    background-color: ${({ theme }) => theme.colors.white};
    margin: ${rem(10)};
    width: 100%;
    max-width: ${rem(520)};
    min-width: ${rem(320)};
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media (min-width: ${breakpoints.xs}px) {
        min-height: ${rem(345)};
    }

    .home-optionCard {
        margin: 0;
        padding: ${rem('10px')};

        &--title {
            margin: ${rem('5px')} ${rem('20px')};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            font-size: ${({ theme }) => theme.fontSizes.textBig};
            text-transform: uppercase;
        }

        &--image {
            margin: 0 auto;
            display: block;
            width: 100%;
        }
    }
`;
